export const DistanceContextDefaultData = {
	from: null,
	error: null,
	errorMessage: null,
}